import React, { useState, useEffect } from "react";
import { useForm } from "../../../../../../hooks/useForm";

export const PlanArrepentimientoModal = ({
    handleClose,
    usuarioData,
    selectedPlan,
    setPlanesToShow
}) => {
    // useForm Hook procesa el input change y setea los valores.
    const [formValues, handleInputChange, reset, setValues] = useForm({
        suscripcion: "",
        plan: "",
        motivo: "",
        grupo: "",
        orden: "",
        nombre: "",
        apellido: "",
        cuit_cuil: ""
    });

    useEffect(() => {
        setValues(prevState => {
            return {
                ...prevState,
                suscripcion: selectedPlan?.Solicitud || "",
                plan: selectedPlan?.descripcion || "",
                grupo: selectedPlan?.Grupo || "",
                orden: selectedPlan?.Orden || "",
                nombre: usuarioData?.Datos?.Nombre || "",
                apellido: usuarioData?.Datos?.Apellido || "",
                cuit_cuil: usuarioData?.Datos?.Numero || ""
            };
        });
        document.getElementById("motivo-focus").focus();
    }, [usuarioData, selectedPlan]);

    const onClose = () => {
        //Limpio el modal
        reset();
        setStep(0);
        setMessage("");
        handleClose();
    };

    //message representa la devolución por parte del Backend
    const [message, setMessage] = useState("");
    const [step, setStep] = useState(0);

    const handleSubmit = async event => {
        event.preventDefault();
        //TODO: Validar datos
        try {
            const endpoint = await (await fetch(`/api/show_endpoints/${selectedPlan.BotonRENARRStatus === 'A' ? 'wsarrepentimiento' : 'wsrenunciaweb'}`)).json();

            const url =
                selectedPlan.BotonRENARRStatus === "A"
                    ? `${endpoint.url_base}${endpoint.url_variable}?Solicitud=${
                          selectedPlan.Solicitud
                      }&MotivoArr=${encodeURIComponent(formValues.motivo)}`
                    : `${endpoint.url_base}${endpoint.url_variable}?CUIT=${
                          usuarioData.Datos.Numero
                      }&Solicitud=${
                          selectedPlan.Solicitud
                      }&MotivoRen=${encodeURIComponent(formValues.motivo)}`;
            let result = await fetch(url);
            result = await result.json();
            console.log(result);
            setMessage(result.MensajeRenuncia);
            setStep(1);
            if (result.ErrorCodigo === "00") {
                setPlanesToShow(prevState => {
                    const pepe = prevState.map(plan => {
                        if (plan.Id !== selectedPlan.Id) return plan;
                        else
                            return {
                                ...plan,
                                EstadoPlan: "Renunciado/Rescindido"
                            };
                    });
                    console.log(pepe);
                    return pepe;
                });
            }
        } catch (err) {
            console.log("Error: ", err);
        }
    };

    return (
        <>
            <div className="form-modalBackdrop"></div>
            <div className="form-modalScreenContainer">
                <div className="form-modalScreen justify-content-start">
                    {step === 0 && (
                        <>
                            <div className="closeButton ">
                                <span onClick={onClose}>X</span>
                            </div>
                            <div className="title">
                                <strong>
                                    Por medio de la presente solicito la baja al
                                    plan de ahorro
                                </strong>
                            </div>
                        </>
                    )}

                    <div className="w-50 h-100 d-flex justify-content-center align-items-center flex-column">
                        {step === 0 ? (
                            <form
                                className="form d-flex justify-content-center align-items-center flex-column"
                                onSubmit={handleSubmit}
                                style={{ minWidth: "400px" }}
                            >
                                <div style={{ width: "100%" }}>
                                    <label htmlFor="suscripcion">
                                        N° de Suscripción
                                    </label>
                                    <input
                                        type="number"
                                        name="suscripcion"
                                        autoComplete="off"
                                        value={formValues.suscripcion}
                                        onChange={handleInputChange}
                                        disabled
                                        className="modal-input"
                                    />
                                </div>
                                <div style={{ width: "100%" }}>
                                    <label htmlFor="plan">Plan</label>
                                    <input
                                        type="text"
                                        name="plan"
                                        autoComplete="off"
                                        value={formValues.plan}
                                        onChange={handleInputChange}
                                        disabled
                                        className="modal-input"
                                    />
                                </div>
                                {formValues.grupo && (
                                    <div style={{ width: "100%" }}>
                                        <label htmlFor="grupo">Grupo</label>
                                        <input
                                            type="number"
                                            name="grupo"
                                            autoComplete="off"
                                            value={formValues.grupo}
                                            onChange={handleInputChange}
                                            disabled
                                            className="modal-input"
                                        />
                                    </div>
                                )}
                                {formValues.orden && (
                                    <div style={{ width: "100%" }}>
                                        <label htmlFor="orden">Orden</label>
                                        <input
                                            type="number"
                                            name="orden"
                                            autoComplete="off"
                                            value={formValues.orden}
                                            onChange={handleInputChange}
                                            disabled
                                            className="modal-input"
                                        />
                                    </div>
                                )}

                                <div style={{ width: "100%" }}>
                                    <label htmlFor="nombre">Nombre</label>
                                    <input
                                        type="text"
                                        name="nombre"
                                        autoComplete="off"
                                        value={formValues.nombre}
                                        onChange={handleInputChange}
                                        disabled
                                        className="modal-input"
                                    />
                                </div>

                                <div style={{ width: "100%" }}>
                                    <label htmlFor="apellido">Apellido</label>
                                    <input
                                        type="text"
                                        name="apellido"
                                        autoComplete="off"
                                        value={formValues.apellido}
                                        onChange={handleInputChange}
                                        disabled
                                        className="modal-input"
                                    />
                                </div>

                                <div style={{ width: "100%" }}>
                                    <label htmlFor="cuit_cuil">CUIT/CUIL</label>
                                    <input
                                        type="number"
                                        name="cuit_cuil"
                                        autoComplete="off"
                                        value={formValues.cuit_cuil}
                                        onChange={handleInputChange}
                                        disabled
                                        className="modal-input"
                                    />
                                </div>
                                <div style={{ width: "100%" }}>
                                    <label htmlFor="motivo">Motivo</label>
                                    <textarea
                                        maxLength="400"
                                        placeholder="Solicito la baja al plan debido a que..."
                                        name="motivo"
                                        autoComplete="off"
                                        rows="3"
                                        value={formValues.motivo}
                                        onChange={handleInputChange}
                                        required
                                        id="motivo-focus"
                                        className="modal-input"
                                    />
                                </div>

                                {selectedPlan &&
                                    selectedPlan.BotonRENARRStatus === "RA" && (
                                        <b>
                                            Tomo conocimiento que la
                                            adjudicación quedará desistida.
                                        </b>
                                    )}

                                <button
                                    className="btn-form mt-half"
                                    type="submit"
                                >
                                    Confirmar
                                </button>
                            </form>
                        ) : (
                            <>
                                {message}
                                <button
                                    className="btn-form mt-half"
                                    onClick={onClose}
                                >
                                    Aceptar
                                </button>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
